import React from 'react'
import List from '../../component/Employers/PremiumList'
import { premiumEmployerList, updateEmployerStatus } from '../../actions/employer'
import { useState, useEffect } from 'react'
import constant from '../../constant'

export default function PremiumList() {

    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [showLoader, setShowLoader] = useState(true)


    useEffect(() => {
        document.title = constant.title.PremiumEmployerList
        premiumEmployerLists(currentPage, "")
    }, [currentPage])

    const premiumEmployerLists = (page, KEYWORD) => {
        premiumEmployerList({ page: page, KEYWORD: KEYWORD }).then(res => {
            setShowLoader(false)
            if (res.status) {
                setList(res.result.list)
                setCount(res.result.count.total)
            }
            else {
                alert(res.error)
            }
        }).catch(err => {
            alert(err)
        })
    }

    const updateStatus = (model) => {
        updateEmployerStatus(model).then(res => {
            if (res.status) {
                premiumEmployerLists(currentPage, "")
            }
        })
    }


    return (
        <React.Fragment>
            <List
                list={list}
                count={count}
                premiumEmployerLists={(page) => { premiumEmployerLists(page) }}
                setPage={setCurrentPage}
                updateStatus={updateStatus}
                setShowLoader={setShowLoader}
                showLoader={showLoader}
            />
        </React.Fragment>
    )
}
